export const MAX_MODULES = 7;
export const MPE_SEMESTER: 1 | 2 = 2;
export const MPE_AY = '2025/2026';
